import { acceptedService as acceptedCookieService } from "vanilla-cookieconsent"


const COOKIE_NAME = 'utm_history';
const COOKIE_VALID_DAYS = 30;

export function updateUtmHistory() {
  // Make sure tracking cookies are accepted
  if (!acceptedCookieService('utmTracker', 'marketing')) return;

  const currentUtm = getUtmParams(window.location.href);

  if (currentUtm) {
    let history = [];
    const existing = getCookie(COOKIE_NAME);
    if (existing) {
      try {
        history = JSON.parse(existing);
      } catch(e) {
        history = [];
      }
    }

    const exists = history.some(item => JSON.stringify(item) === JSON.stringify(currentUtm));
    if (!exists) {
      history.push(currentUtm);
    }

    setCookie(COOKIE_NAME, JSON.stringify(history), COOKIE_VALID_DAYS);
  }
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
  return null;
}

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days*24*60*60*1000));
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

function getUtmParams(url) {
  const urlObj = new URL(url);
  const utmParams = {};
  urlObj.searchParams.forEach((value, key) => {
    if (/^utm_(source|medium|campaign|term|content)$/i.test(key)) {
      utmParams[key] = value;
    }
  });
  return Object.keys(utmParams).length ? utmParams : null;
}